<template>
    <div id="financeDetail" class="sys-page">
        <div class="page-head">
            <p class='el-icon-back goback' @click="back()">返回</p>
        </div>
        <el-card class="box-card">
            <p class="title">账户信息</p>
            <div>
                <p class="list">账户余额 ：
                    <span style="color:red;">{{balanceMsg.rechargeBalance}} 元</span>
                    <el-button style="margin-left:50px;" type="primary" @click="editAccount=true" size="small">修改</el-button>
                </p>
            </div>
            <p class="title">医院信息</p>
            <div>
                <div class="list">
                    <span class="keyWord">医院编号 : </span><span class="content">{{hospMsg.hospVo.hospCode}}</span>
                </div>
                <div class="list">
                    <span class="keyWord">医院名称 : </span><span class="content">{{hospMsg.hospVo.hospName}}</span>
                </div>
                <div class="list">
                    <span class="keyWord">医院负责人 : </span><span class="content">{{hospMsg.hospVo.hospAdminName}}</span>
                </div>
                <div class="list">
                    <span class="keyWord">医院电话 : </span><span class="content">{{hospMsg.hospVo.hospAdminTel}}</span>
                </div>
                <div class="list">
                    <span class="keyWord">医院等级 : </span><span class="content">{{hospMsg.hospVo.hospRank}}</span>
                </div>
                <div class="list">
                    <span class="keyWord">医院地址 : </span><span class="content">{{hospMsg.hospVo.hospAddr}}</span>
                </div>
                <div class="list">
                    <span class="keyWord">医院简介 : </span><span class="content">{{hospMsg.hospVo.hospDesc}}</span>
                </div>
                <p class="list">管理员姓名 ：{{hospMsg.saName}}</p>
                <p class="list">管理员账号 ：{{hospMsg.saTel}}</p>
            </div>
            <p class="title">交易记录</p>
            <div style="backgroundColor:#fff;text-align:left">
                <el-form :inline="true" :model="searchForm" style="padding:0 10px;">
                    <el-form-item label="交易类型">
                        <el-select v-model="searchForm.payType" placeholder="请选择"  style="width:150px;">
                            <el-option key="" label="全部" value=""></el-option>
                            <el-option key="01" label="支付" value="01"></el-option>
                            <el-option key="02" label="充值" value="02"></el-option>
                            <el-option key="03" label="收款" value="03"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="时间">
                        <el-date-picker v-model="date" @change="change"
                        :picker-options="pickerBeginDateBefore"
                        format="yyyy-MM-dd"
                        value-format="yyyy-MM-dd"
                        type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="getRecord(1)">查询</el-button>
                        <el-button type="primary" @click="clear()">清除</el-button>
                    </el-form-item>
                </el-form>
            </div>
            <div class="main-data">
                <el-table :data="tableData.body" style="width: 98%;margin:0 auto">
                    <el-table-column header-align=center align="center" type=index label="序号" width="50"></el-table-column>
                    <el-table-column header-align=center align="center" prop='orderNo' label="订单号"></el-table-column>
                    <el-table-column header-align=center align="center" prop='payType' label="交易类型" :formatter="transfPay"></el-table-column>
                    <el-table-column header-align=center align="center" label="交易金额">
                        <template slot-scope="scope">
                            <span v-if="scope.row.payType === '01'">- {{ scope.row.payTotal }}</span>
                            <span v-if="scope.row.payType === '02'" class="greenColor">+ {{ scope.row.payTotal }}</span>
                            <span v-if="scope.row.payType === '03'" class="redColor">+ {{ scope.row.payTotal }}</span>
                            <span v-if="scope.row.payType === '04'">- {{ scope.row.payTotal }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column header-align=center align="center" prop='payTime' label="交易时间"></el-table-column>
                    <el-table-column header-align=center align="center" prop='creatorName' label="操作人"></el-table-column>
                </el-table>
                <div class="page">
                    <el-pagination  :page-size="10" :page-count="5" layout="total, prev, pager, next" :total="tableData.count" @current-change='currentChange' style="text-align:right"></el-pagination>
                </div>
            </div> 
        </el-card>
        <el-dialog title="修改账户余额" :visible.sync="editAccount" width="600px" center>
            <el-form ref="accountMsg" :model="accountMsg" :rules="accountMsgRules" label-width="120px">
                <el-form-item label="余额加减" prop="chargeStatus">
                    <el-radio-group v-model="accountMsg.chargeStatus" class="radioGroup">
                        <el-radio v-model="accountMsg.chargeStatus" label="-">减</el-radio>
                        <el-radio v-model="accountMsg.chargeStatus" label="">加</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="金额" prop="money">
                    <el-input style="width:80%;margin-right:10px" type="text" placeholder="请输入要加减的金额" v-model="accountMsg.money"></el-input> 元
                </el-form-item>
                <div style="display:flex;justify-content:flex-end;margin-top:40px;">
                    <el-button size='small' @click="cancel()">取消</el-button>
                    <el-button type="primary" size='small' @click="update()">保存</el-button>
                </div>
            </el-form>
        </el-dialog>
    </div>
</template>

<script>
import {isMoney,isSetMoney,isvalidCallAndPhone,isvalidPhone} from '@/service/common'
import { Loading } from 'element-ui';
//定义一个全局的变量，金额验证 
var validMoney=(rule, value,callback)=>{
    if (!value){
        callback(new Error('请输入金额'))
    }else  if (!isMoney(value)){
        callback(new Error('金额格式错误!'))
    }else {
        callback()
    }
}
export default {
    name:'hospDetail',
    data(){
        return{
            pickerBeginDateBefore:{
                disabledDate: (time) => {
                    return time.getTime() > new Date();
                }
            },
            //医院信息
            hospMsg:{
                hospVo:{}
            },
            editAccount:false,//修改医院账户
            accountMsg:{
                chargeStatus:'-',
                money:''
            },
            accountMsgRules:{
                money:[{ required: true, trigger: 'blur', validator: validMoney }]
            },
            //账户信息
            balanceMsg:{
                standardPrice:300,
                chargeStatus:'01'
            },
            //交易记录时间筛选
            date:'',
            searchForm:{
                hospId:'',
                payType:'',
                startTime:'',
                endTime:'',
                page:1,
                rows:10
            },
            //交易记录
            tableData:{
                count:0,
                body:[],
                page:1
            },
            loadingInstance:''
        }
    },
    mounted(){
        this.hospMsg=this.$common.getStorage('hospMsg');
        this.searchForm.hospId=this.hospMsg.hospVo.hospId;
        this.getAccount(this.hospMsg.hospVo.hospId);
        this.getRecord(1);
    },
    methods:{
        //获取账户信息
        getAccount(hospId){
            this.$ajax.post(this.$domain.getCharge,{
                hospId:hospId
            })
            .then(ret=>{
                console.log(ret.data)
                if(ret.data.code==10){
                    this.balanceMsg=ret.data.data;
                }
                else if(res.code=='401'){
                    this.$message.error('登录失效，请重新登录！');
                    this.$router.push({path:'/login'})
                }
                else{
                    console.log(res)
                    this.$message.error('查询医院账户信息失败！');
                }
            })
        },
        //修改余额
        update(){
            this.$refs['accountMsg'].validate((valid)=>{
                if(valid){
                    if(this.accountMsg.money=='0'||this.accountMsg.money=='0.0'||this.accountMsg.money=='0.00'){
                        this.$message.error('余额没有变化，无需修改！');
                        return;
                    }
                    else if(this.accountMsg.chargeStatus=='-'&&this.accountMsg.money>this.balanceMsg.rechargeBalance){
                        this.$message.error('余额不足!');
                        return;
                    }
                    var txt='';
                    if(this.accountMsg.chargeStatus=='-'){
                        txt='确定为该医院减少'+this.accountMsg.money+'元的账户余额？';
                    }
                    else{
                        txt='确定为该医院增加'+this.accountMsg.money+'元的账户余额？';
                    }
                    this.$confirm(txt, '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        this.loadingInstance=Loading.service({
                            text:'医院账户信息修改中...',
                            spinner:'el-icon-loading',
                            background:'rgba(0, 0, 0, 0.8)'
                        });
                        var obj={
                            hospId:this.hospMsg.hospVo.hospId,
                            hospName:this.hospMsg.hospVo.hospName,
                            amount:this.accountMsg.chargeStatus+this.accountMsg.money
                        }
                        console.log(obj);
                        this.$ajax.post(this.$domain.update,obj)
                        .then(ret=>{
                            this.loadingInstance.close();
                            console.log(ret.data)
                            if(ret.data.code==10){
                                this.$message.success('账户余额修改成功！');
                                this.getAccount(this.hospMsg.hospVo.hospId);
                                this.getRecord(1);
                                this.cancel();
                            }
                            else if(ret.data.code=='32'){
                                this.$message.error('修改账户余额失败！余额不足');
                                return;
                            }
                            else if(ret.data.code=='401'){
                                this.$message.error('登录失效，请重新登录！');
                                this.$router.push({path:'/login'})
                            }
                            else{
                                console.log(res)
                                this.$message.error('修改账户余额失败！');
                            }
                        })
                        .catch(() => {
                            this.loadingInstance.close();    
                        });
                    }).catch(() => {
                                  
                    });
                }
            })
            
        },
        //是否收费转换
        transfCharge(val){
            switch(val){
                case '01':return '是';break;
                case '02':return '否';break;
            }
        },
        //返回
        back(){
            this.$router.go(-1);
        },
        //清空
        cancel(){
            this.editAccount=false;
            this.accountMsg={
                chargeStatus:'-',
                money:''
            };
            this.$refs['accountMsg'].resetFields();
        },
        //获取交易记录
        getRecord(page){
            this.searchForm.page=page;
            this.$ajax.post(this.$domain.listPayRecord,this.searchForm)
            .then(ret=>{
                console.log(ret.data)
                if(ret.data.code==10){
                    this.tableData.body=ret.data.data.list;
                    this.tableData.count=ret.data.data.count;
                }
                else if(ret.data.code=='401'){
                    this.$message.error('登录失效，请重新登录！');
                    this.$router.push({path:'/login'});
                }
                else{
                    this.$message.error(ret.data.data.message);
                }
            })
        },
        //交易记录分页
        currentChange(val){
            console.log(val)
            this.getRecord(val)
        },
        //选择时间
        change(val){
            this.searchForm.startTime=val[0]+' 00:00:00';
            this.searchForm.endTime=val[1]+' 23:59:59';
        },
        //交易类型文字转换
        transfPay(row){
            switch(row.payType){
                case '01':return '支付';break;
                case '02':return '充值';break;
                case '03':return '收款';break;
                case '04':return '提现';break;
            }
        },
    }
}
</script>

<style lang="scss" scoped>
#financeDetail{
    width:100%;
    min-width: 1200px;
    padding:0 10%;
    box-sizing: border-box;
    width: 100%;
    height: 100%;
    overflow-x: hidden;
    overflow-y: auto;
    .page-head{
        text-align: left;
        margin-top:30px;
        color:#5c6bc0;
    }
    .goback{
        cursor: pointer;
        font-size: 20px;
    }
    .box-card{
        width:100%;
        margin:20px auto;
        padding:20px;
        max-width:1600px;
        .title{
            font-size: 18px;
            margin-top:10px;
            margin-bottom:30px;
            text-align: left;
            color:#5c6bc0;
            font-weight: bold;
            padding:10px 10px;
            border-bottom:1px solid #5c6bc0;
            position: relative;
            .editMsg{
                position: absolute;
                display: inline-block;
                top:12px;
                right:20px;
                width:20px;
                height:20px;
                cursor: pointer;
            }
        }
        .list{
            display: flex;
            justify-content: flex-start;
            padding:10px 20px;
            box-sizing: border-box;
            font-size: 16px;
            color:#333;
            line-height: 30px;
            .keyWord{
                margin-right:20px;
                width:90px;
                text-align: right;
            }
            .content{
                width:84%;
                text-align: left;
            }
            .el-radio-group{
                padding-top:10px;
                box-sizing: border-box;
            }
            .editPwd{
                color:#5c6bc0;
                margin-left:50px;
                cursor: pointer;
                font-size: 14px;
            }
        }
        .list-right{
            text-align:right;
            padding:10px;
            box-sizing: border-box;
        }
    }
    .redColor{
        color:red;        
    }
    .greenColor{
        color:#2BB60B;
    }
}
</style>



// WEBPACK FOOTER //
// src/page/financeDetail.vue